import React from "react";
import { Reveal, Stagger, StaggerItem } from "@/components/motion/Reveal";
import { STOCK, ASSETS } from "@/data/content";
import { useI18n } from "@/i18n";
import { CraneDivider } from "@/components/CraneMotifs";
import { SectionCta } from "@/components/SectionCta";

export default function Hosts() {
  const { t } = useI18n();
  const h = t.hosts;
  return (
    <section
      id="gospodarze"
      data-testid="hosts-section"
      className="relative bg-canvas-soft py-14 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-8 md:gap-16 items-center">
          <div className="col-span-12 md:col-span-6 order-2 md:order-1">
            <Reveal>
              <p className="overline mb-6">{h.overline}</p>
              <h2 className="serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-ink">
                {h.headingA} <span className="italic text-brand-red/80">{h.headingAnd}</span> {h.headingB}
              </h2>
            </Reveal>

            <Reveal delay={0.15}>
              <p className="mt-8 text-ink-muted text-base md:text-lg leading-relaxed max-w-md">
                {h.p1}
              </p>
              <p className="mt-5 text-ink-muted text-base md:text-lg leading-relaxed max-w-md">
                {h.p2}
              </p>
            </Reveal>

            <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-10">
              <Reveal delay={0.2}>
                <p className="serif italic text-3xl text-ink mb-3">{h.ewaName}</p>
                <p className="overline text-brand-red mb-4">{h.ewaTag}</p>
                <p className="text-ink-muted text-sm leading-relaxed">
                  {h.ewaDesc}
                </p>
              </Reveal>
              <Reveal delay={0.3}>
                <p className="serif italic text-3xl text-ink mb-3">{h.jacekName}</p>
                <p className="overline text-brand-red mb-4">{h.jacekTag}</p>
                <p className="text-ink-muted text-sm leading-relaxed">
                  {h.jacekDesc}
                </p>
              </Reveal>
            </div>
          </div>

          <div className="col-span-12 md:col-span-6 order-1 md:order-2">
            <Reveal>
              <div className="relative">
                <img
                  src={ASSETS.hosts}
                  alt={h.hostsAlt}
                  className="w-full h-[500px] md:h-[720px] object-cover"
                />
              </div>
            </Reveal>
          </div>
        </div>

        {/* Dogs & cottage — 1x3 justified row, dogs shown uncropped */}
        <Stagger className="mt-14 md:mt-20 flex flex-col md:flex-row gap-6 md:gap-8 md:justify-center md:items-start">
          <StaggerItem className="md:h-[400px]">
            <figure className="md:h-[400px] flex flex-col">
              <div className="md:h-[400px] overflow-hidden group">
                <img
                  src={ASSETS.dogBolek}
                  alt={h.bolekAlt}
                  className="w-full h-auto md:w-auto md:h-full object-cover group-hover:scale-[1.05] transition-transform duration-700 ease-out"
                />
              </div>
              <figcaption className="mt-4 serif italic text-2xl text-ink text-center">
                {h.bolek}
              </figcaption>
            </figure>
          </StaggerItem>

          <StaggerItem className="md:h-[400px]">
            <figure className="md:h-[400px] flex flex-col">
              <div className="md:h-[400px] overflow-hidden group">
                <img
                  src={ASSETS.hostsCottage}
                  alt={h.ourPlaceAlt}
                  className="w-full h-auto md:w-auto md:h-full object-cover group-hover:scale-[1.05] transition-transform duration-700 ease-out"
                />
              </div>
              <figcaption className="mt-4 overline text-center">
                {h.ourPlace}
              </figcaption>
            </figure>
          </StaggerItem>

          <StaggerItem className="md:h-[400px]">
            <figure className="md:h-[400px] flex flex-col">
              <div className="md:h-[400px] overflow-hidden group">
                <img
                  src={ASSETS.dogTola}
                  alt={h.tolaAlt}
                  className="w-full h-auto md:w-auto md:h-full object-cover group-hover:scale-[1.05] transition-transform duration-700 ease-out"
                />
              </div>
              <figcaption className="mt-4 serif italic text-2xl text-ink text-center">
                {h.tola}
              </figcaption>
            </figure>
          </StaggerItem>
        </Stagger>

        <Reveal className="mt-14 md:mt-20 flex justify-center">
          <SectionCta to="/domek" testid="hosts-cta-domek">
            {h.cta}
          </SectionCta>
        </Reveal>

        <Reveal className="mt-12 md:mt-16">
          <CraneDivider />
        </Reveal>
      </div>
    </section>
  );
}
